// extracted by mini-css-extract-plugin
export default {"button":"mm-z","reviewSort":"nm-z"};